var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinanceCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Binance Coin (BNB)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Binance Coin (BNB)_2",
    d: "M47.2766 30.3057C44.0712 43.163 31.0489 50.9877 18.1901 47.7815C5.33667 44.5761 -2.48802 31.553 0.718765 18.6967C3.92273 5.83806 16.9451 -1.98721 29.7999 1.21816C42.6577 4.42354 50.4819 17.4481 47.2762 30.306L47.2765 30.3057H47.2766Z",
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Binance Coin (BNB)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9999 15.732L17.7853 21.9467L17.7854 21.9464L14.1695 18.3304L23.9999 8.5L33.8335 18.3333L30.2175 21.9493L23.9999 15.732ZM11.6161 20.8834L8 24.5L11.6159 28.1154L15.232 24.4992L11.6161 20.8834ZM17.7853 27.0537L24 33.268L30.2174 27.0508L33.8354 30.6649L33.8336 30.6668L24 40.5L14.1696 30.6696L14.1645 30.6645L17.7853 27.0537ZM36.3841 20.8854L32.768 24.5015L36.384 28.1174L40 24.5013L36.3841 20.8854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Binance Coin (BNB)_4",
    d: "M27.6677 24.498H27.6693L24.0003 20.8288L21.2883 23.54L20.9768 23.8516L20.3342 24.4943L20.3291 24.4993L20.3342 24.5046L24.0003 28.1711L27.6695 24.5019L27.6713 24.4998L27.668 24.498",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceCoin);
export default __webpack_public_path__ + "static/media/BinanceCoin.ac2c55f68b5358660799837c23f13016.svg";
export { ForwardRef as ReactComponent };